import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { StatsCardProps } from '@/lib/types';
import { cn } from '@/components/ui/utils';

export function StatsCard({ title, value, icon, description, onClick }: StatsCardProps) {
  return (
    <Card
      className={cn(onClick && 'cursor-pointer transition-colors hover:bg-gray-50')}
      onClick={onClick}
    >
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-gray-600">{title}</CardTitle>
        {icon}
      </CardHeader>
      <CardContent>
        <div className="text-2xl sm:text-3xl font-bold text-gray-900">{value}</div>
        {description && <p className="text-xs text-gray-500 mt-1">{description}</p>}
      </CardContent>
    </Card>
  );
}
